import { render } from "./Home.vue?vue&type=template&id=9abe21de&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\appdevvm\\Desktop\\Gemfarm\\gem-farm-main\\gem-farm-main\\app\\gem-bank\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__